module.exports = __webpack_public_path__ + "static/sepa-logo-f722a177aeccbb1c48cce006c0b2ab48.svg";